import { AppDispatch, RootState } from 'store/types';
import axiosClient from 'services/network/apiClient';
import { AccountState } from './types';
import { logError } from 'utils/logs';


export function createNewAccount() {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        const { firstname, lastname, phone, email } = getState().account;
        const AUTH_URL = new URL(`${(process.env.REACT_APP_DEBUG ? 'https://dev-auth.ayomi.fr' : 'https://auth.ayomi.fr')}/create-account`);
        AUTH_URL.searchParams.append('firstname', firstname);
        AUTH_URL.searchParams.append('lastname', lastname);
        AUTH_URL.searchParams.append('email', email);
        AUTH_URL.searchParams.append('phone', phone);
        AUTH_URL.searchParams.append('auto_login', '1');
        AUTH_URL.searchParams.append('redirect', `${window.location.href.split('?')[0]}/paiement`);
        window.location.assign(AUTH_URL);
    };
}

export function getReservationId() {
    return async (dispatch: AppDispatch) => {
        const decomposeUrl = document.URL.split('?')[0].split('/');
        decomposeUrl.pop();
        const reservationId = decomposeUrl[decomposeUrl.length - 1];
        dispatch({ type: 'UPDATE_RESERVATION_ID', payload: reservationId });
    }
}

export const getValidInvestmentAmount = (amount: number, { stockPrice }: { stockPrice: number }) => {
    if (amount < stockPrice) return stockPrice;
    return Math.round(amount / stockPrice) * stockPrice;
};

export function fetchAccountDataFromURL() {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(getReservationId());
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('prenom')) {
            dispatch({ type: 'UPDATE_FIRSTNAME', payload: urlParams.get('prenom') });
        }
        if (urlParams.get('nom')) {
            dispatch({ type: 'UPDATE_LASTNAME', payload: urlParams.get('nom') });
        }
        if (urlParams.get('email')) {
            dispatch({ type: 'UPDATE_MAIL', payload: urlParams.get('email') });
        }
        if (urlParams.get('num')) {
            dispatch({ type: 'UPDATE_PHONE', payload: urlParams.get('num') });
        }
        if (urlParams.get('amount')) {
            dispatch({ type: 'SET_ACCOUNT_DATA', payload: { investment: getValidInvestmentAmount(parseFloat(urlParams.get('amount') || '0'), getState().investments) } });
        }
    };
}

export function setAccountData(data: Partial<AccountState>) {
    return (dispatch: AppDispatch) => {
        if (data.investment) {
            window.sessionStorage.setItem('amount', data.investment.toString());
            dispatch({ type: 'UPDATE_AMOUNT', payload: data.investment });
        }
        if (data.wantInvestBySociety) {
            window.sessionStorage.setItem('from_company', data.wantInvestBySociety.toString());
        }
        dispatch({ type: 'SET_ACCOUNT_DATA', payload: data });
    }
}

export function investBySociety(bool: boolean) {
    return async (dispatch: AppDispatch) => {
        dispatch({ type: 'UPDATE_SOCIETY', payload: bool });
    };
}

export function sendIban(value: string) {
    return async (dispatch: AppDispatch) => {
        dispatch({ type: 'SEND_IBAN_REQUEST' });
        try {
            const { data } = await axiosClient.post('/iban', { value });
            dispatch({ type: 'SEND_IBAN_SUCCESS', payload: data });
        } catch (err) {
            logError(err as Error);
            dispatch({ type: 'SEND_IBAN_FAIL', payload: err });
        }
    }
}

export function updateIban(value: string) {
    return (dispatch: AppDispatch) => {
        dispatch({ type: 'UPDATE_IBAN_GAIN', payload: value });
    }
}